import { Box, Typography } from "@mui/material";
import { DownloadLinkWithText } from "./Reuseables/Links/Links";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Resource } from "../types/resource";




export default function ResourcePage() {
  const { t, i18n } = useTranslation();
  const [resources, setResources] = useState<Resource[]>([]);
  
  useEffect(() => {
      setResources(resourceList);
  }, [i18n.language]);
  
  const resourceList: Resource[] = 
  [
    {title : "onePager", fileName: `https://precure-cdn.azureedge.net/files/mli-interface/resources/Participant_one_pager_${i18n.language}.pdf`},
    {title : "onboardingChecklist", fileName: `https://precure-cdn.azureedge.net/files/mli-interface/resources/Onboarding_Checklist_${i18n.language}.pdf`},
  ]
  


  return (
    <Box
      display={"flex"}
      width={"100%"}
      height={"85vh"}
      justifyContent="center"
    >
      <Box flexDirection={"column"}>
        <Typography variant="h3"> {t("buttons.resources")}:</Typography>
        {/* <Typography mt={10} variant="h4">
          {t("resourcePage.introToTheInterface")}
        </Typography>
        <Typography mt={1} variant="h4">
          {t("resourcePage.duringMeasurement")}
        </Typography>
        <Typography mt={1} variant="h4">
          {t("resourcePage.readyForOnboarding")}
        </Typography> */}
        {resources.map((r, i) => {
          return (
            <DownloadLinkWithText
              key={i}
              href={r.fileName}
              linkText={
                <Typography mt={1} variant="h4">
                   {t(r.title)}
                </Typography>
              }
            />
          );
        })}
      </Box>
    </Box>
  );
}
